import { useState } from "react"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

interface CInputProps {
    label?: string
    value: string
    placeholder?: string
    onChange: (val: string) => void
    onFocus?: () => void
    onBlur?: () => void
}

const CInputCom = ({label = '', value, placeholder, onChange, onFocus = () => {}, onBlur = () => {}}: CInputProps) => {
    const [isFocus, setIsFocus] = useState(false)

    const fnFocus = () => {
        setIsFocus(true)
        onFocus()
    }

    const fnBlur = () => {
        setIsFocus(false)
        onBlur()
    }

    const fnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value.trim()
        onChange(val)
    }

    return <CInputWrap $isFocus={isFocus} $isVal={!!value}>
        <FormLabelWrap $roobertRegular>{label}</FormLabelWrap>
        <FormInputWrap value={value} placeholder={placeholder} onFocus={fnFocus} onBlur={fnBlur} onChange={fnChange}></FormInputWrap>
    </CInputWrap>
}

const CInputWrap = styled(StyledContainer)<{$isFocus: boolean, $isVal?: boolean}>`
    height: 62px;
    border: 1px solid #DFE0E2;
    border-radius: 9px;
    padding: 14px 16px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    ${
        ({$isFocus}) => $isFocus ? css`
            background-color: #ffffff !important;
            border-color: #DFE0E2 !important;
        ` : css`
            background-color: #F4F5F5;
            border-color: #F4F5F5;

            ${FormLabelWrap} {
                font-size: 20px;
                font-weight: 600;
                font-family: RoobertSemiBold;
                color: #CACCCE;
                top: 7px;
            }

            ${FormInputWrap} {
               height: 100%;
               position: absolute;
               top: 0;
               left: 0;

               &::placeholder {
                    color: transparent;
                }
            }
        `
    }

    ${
        ({$isVal}) => $isVal ? css`
            background-color: #F4F5F5;
            border-color: #F4F5F5;
            ${FormLabelWrap} {
                font-size: 12px;
                font-weight: 400;
                font-family: RoobertRegular;
                top: 0px;
                color: #0a0a0a;
            }

            ${FormInputWrap} {
                height: auto;
                position: relative;
            }
        `:css`
          
        `
    }
`

const FormLabelWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 400;
    font-family: RoobertRegular;
    line-height: 1;
    
    position: relative;
`

const FormInputWrap = styled.input`
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    font-family: RoobertSemiBold;
    outline: none;
    border: none;
    width: 100%;
    background-color: transparent;

    &::placeholder {
        color: #CACCCE;
    }
`

export default CInputCom